import { api } from './client'

export type MensagemAcervo = {
  id: number
  tipo: 'USUARIO' | 'ATENDENTE' | string | null
  categoria: string | null
  tipoMensagem: string | null
  texto: string | null
  autor: string | null
  em: string | null
  arquivo: { nome: string | null; disponivel: boolean } | null
}

export type AnexoAcervo = {
  id: number
  nome: string | null
  fluxo: string | null
  em: string | null
  disponivel: boolean
}

export type AtendimentoAcervo = {
  protocolo: number
  nome: string | null
  numero: string | null
  data: string | null
  dataUltimaMensagem: string | null
  status: string | null
  origem: string | null
  departamento: string | null
  atendente: string | null
  mensagens: MensagemAcervo[]
  anexos: AnexoAcervo[]
}

export type ContatoAcervo = {
  numero: string | null
  nome: string | null
  atendimentos: number
  ultimo: string | null
}

export const buscarContatos = (busca: string) =>
  api.get<ContatoAcervo[]>(`/acervo/contatos?busca=${encodeURIComponent(busca)}`)

/** Um atendimento do acervo, pelo protocolo — o que a linha do tempo abre. */
export const buscarAtendimento = (protocolo: number) =>
  api.get<AtendimentoAcervo>(`/acervo/atendimento/${protocolo}`)

export const buscarConversa = (numero: string) =>
  api.get<AtendimentoAcervo[]>(`/acervo/conversa?numero=${encodeURIComponent(numero)}`)

// Link direto (href de <a>, src de <img>) não passa por fetch, então não leva
// cabeçalho: aqui a chave vai na querystring mesmo. Sai junto com o P-03.
function comChave(caminho: string) {
  const base = import.meta.env.VITE_API_URL ?? ''
  const k = new URLSearchParams(window.location.search).get('k')
  return `${base}${caminho}${k ? `?k=${encodeURIComponent(k)}` : ''}`
}

export const urlAnexo = (protocolo: number, id: number) =>
  comChave(`/acervo/anexo/${protocolo}/${id}`)

/** Anexo da própria mensagem — aberto na posição em que foi enviado. */
export const urlArquivoMensagem = (protocolo: number, id: number) =>
  comChave(`/acervo/mensagem/${protocolo}/${id}/arquivo`)
